var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 text-center"},[_c('b-col',[_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}),_c('small',[_vm._v(_vm._s(_vm.$t("Loading data")))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }